import React, {useState} from 'react';
import { Col, Row } from 'reactstrap';

import {ButtonNew} from "../../../components/buttons/buttonsActions";
import TypeDestinationActivityList from "./_list";
import TypeDestinationActivityForm from "./_form";

export default function TypeDestinationActivity() {
    const [editMode, setEditMode] = useState(false);
    const [item, setItem] = useState();

    const [viewMode, setViewMode] = useState("LIST")

    const setForm = (editModeP, data, viewModeP) => {
        setEditMode(editModeP ? editModeP : editMode);
        setItem(data);
        setViewMode(viewModeP ? viewModeP : "LIST")
    }

    const updateItem = (item) => {
        setItem(item)
    }

    return (
        <div>
            <Row>
                <Col md="12">
                    <div className="d-flex align-items-center">
                        {
                            viewMode === "LIST" ?
                                <div className="ml-auto paddingAdd">
                                    <ButtonNew onClick={() => setForm(null, null, "FORM")}/>
                                </div> : null
                        }
                    </div>
                </Col>
            </Row>
            {(
                function() {
                    switch (viewMode) {
                        case "LIST" :
                            return (
                                <Row>
                                    <Col md="12">
                                        <TypeDestinationActivityList setForm={setForm} />
                                    </Col>
                                </Row>
                            );
                        case "FORM" :
                            return (
                                <Row>
                                    <Col md="12">
                                        <TypeDestinationActivityForm setForm={setForm} updateItem={updateItem} item={item} editMode={editMode} />
                                    </Col>
                                </Row>
                            );
                        default:
                            return null;
                    }
                })()}
        </div>
    );
}